import { Component } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'
import { RolloutsMapMetrics } from 'src/app/shared/metrics/rollouts-map-metrics'
@Component({
  selector: 'app-rollouts-tile-data',
  templateUrl: './rollouts-tile-data.component.html',
  standalone: false,
})
export class RolloutsTileDataComponent {
  public layerIds = Layers
  public RolloutsMapMetrics = RolloutsMapMetrics
  public isRolloutsTileLayerVisible: boolean
  public isRolloutsMatchedSignsLayerVisible: boolean
  public isRolloutsFilteredMatchedSignsLayerVisible: boolean = false
  public currentMetric: string = this.RolloutsMapMetrics.RolloutsMap_SpeedLimit
  public detailsOpen = false

  constructor(private appState: AppStateService) {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          layer == Layers.RolloutsTile.name ||
          layer == Layers.RolloutsMatchedSignsTile.name ||
          layer == Layers.RolloutsFilteredMatchedSignsTile.name,
      )
    const metrics = this.appState.selectMetrics()

    if (layers && layers.length > 0) {
      this.isRolloutsTileLayerVisible = layers?.some((layer) => layer === Layers.RolloutsTile.name)
      this.isRolloutsMatchedSignsLayerVisible = layers?.some(
        (layer) => layer === Layers.RolloutsMatchedSignsTile.name,
      )
      this.isRolloutsFilteredMatchedSignsLayerVisible = layers?.some(
        (layer) => layer === Layers.RolloutsFilteredMatchedSignsTile.name,
      )

      if (metrics && metrics.length > 0) {
        // Check if current metric exists in the metrics array
        const foundMetric = metrics.find(
          (metric) =>
            metric === this.RolloutsMapMetrics.RolloutsMap_SpeedLimit ||
            metric === this.RolloutsMapMetrics.RolloutsMap_Probability,
        )
        // Use found metric or default to first available metric
        this.currentMetric = foundMetric || metrics[0]
      }
    } else {
      this.isRolloutsMatchedSignsLayerVisible = false
      this.isRolloutsTileLayerVisible = false
    }
    this.updateQueryParameters()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.RolloutsTile.name:
        this.isRolloutsTileLayerVisible = !this.isRolloutsTileLayerVisible
        break
      case Layers.RolloutsMatchedSignsTile.name:
        this.isRolloutsMatchedSignsLayerVisible = !this.isRolloutsMatchedSignsLayerVisible
        break
      case Layers.RolloutsFilteredMatchedSignsTile.name:
        this.isRolloutsFilteredMatchedSignsLayerVisible =
          !this.isRolloutsFilteredMatchedSignsLayerVisible
        break
      default:
        break
    }
    // Ensure detailsOpen is updated after visibility changes
    setTimeout(() => {
      this.detailsOpen = !!this.isRolloutsTileLayerVisible
    })
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          !(layer == Layers.RolloutsTile.name) &&
          !(layer == Layers.RolloutsMatchedSignsTile.name) &&
          !(layer == Layers.RolloutsFilteredMatchedSignsTile.name),
      )

    const metrics = this.appState
      .selectMetrics()
      .filter(
        (metric) =>
          !(
            metric == this.RolloutsMapMetrics.RolloutsMap_Probability ||
            metric == this.RolloutsMapMetrics.RolloutsMap_SpeedLimit
          ),
      )

    if (this.isRolloutsTileLayerVisible) {
      layers.push(Layers.RolloutsTile.name)
      if (!metrics.find((metric) => metric === this.currentMetric)) {
        metrics.push(this.currentMetric)
      }
    }
    if (this.isRolloutsMatchedSignsLayerVisible) {
      layers.push(Layers.RolloutsMatchedSignsTile.name)
    }
    if (this.isRolloutsFilteredMatchedSignsLayerVisible) {
      layers.push(Layers.RolloutsFilteredMatchedSignsTile.name)
    }

    this.appState.setState(AppPaths.Internal, {
      metrics: metrics?.toString(),
      layers: layers?.toString(),
    })
  }

  selectMetric(metric: string) {
    this.currentMetric = metric
    this.updateQueryParameters()
  }

  ngOnInit() {
    const layers = this.appState.selectLayers()
    if (layers) {
      this.isRolloutsTileLayerVisible = layers?.some((layer) => layer === Layers.RolloutsTile.name)
      this.isRolloutsMatchedSignsLayerVisible = layers?.some(
        (layer) => layer === Layers.RolloutsMatchedSignsTile.name,
      )
      this.isRolloutsFilteredMatchedSignsLayerVisible = layers?.some(
        (layer) => layer === Layers.RolloutsFilteredMatchedSignsTile.name,
      )
    } else {
      this.isRolloutsTileLayerVisible = false
      this.isRolloutsMatchedSignsLayerVisible = false
      this.isRolloutsFilteredMatchedSignsLayerVisible = false
    }
    this.detailsOpen = !!this.isRolloutsTileLayerVisible
  }
}
